import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MsalService } from '@azure/msal-angular';
import { GraphService } from 'src/app/services/graph.service';
import { PoOrderDataServiceService } from 'src/app/services/po-order-data-service.service';
import { ReportsService } from 'src/app/services/reports.service';
import { SsoSecurityService } from 'src/app/services/sso-security.service';
import { UserService } from 'src/app/services/user.service';
import { ApproveDialogComponent } from '../../approve-dialog/approve-dialog.component';
import { ApprovedDialogComponent } from '../../approved-dialog/approved-dialog.component';
import { OrderDetails } from '../../model/orderdetails';
import { OrderDetailsResponse } from '../../model/orderdetailsresponse';

import { SortableColumn } from '../../model/sort/sortable-column';
import { YesNoDynamicTitleMessageDialogComponent } from '../../yes-no-dynamic-title-message-dialog/yes-no-dynamic-title-message-dialog.component';
import { OrderdetailsComponent } from '../orderdetails/orderdetails.component';
import { DateAdapter } from '@angular/material/core';
import { SessionStorageService } from 'ngx-webstorage';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { StoreMaintainenceResponse } from '../../model/store-maintainence-response';


@Component({
    selector: 'app-receipt-confirmation',
    templateUrl: './receipt-confirmation.component.html',
    styleUrls: ['./receipt-confirmation.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class ReceiptConfirmationComponent extends OrderdetailsComponent {
  rcSummaryForm: UntypedFormGroup;

  maxDate: Date;
  viewDetailsEnable: boolean = true;
  dateTimeFormat: string = 'yyyy-MM-dd hh:mm:ss a';
  dateFormat: string = 'yyyy-MM-dd';
  @BlockUI() blockUI: NgBlockUI;
  signReceived:boolean;
  //displayedColumns: string[] = ['productdescription', 'orderqty', 'upc', 'din','orderunit','discrepancy'];
  displayedColumns: string[] = ['itemDescription', 'orderedquantity', 'quantity', 'itemNumber','din','orderunit','discrepancy'];

  constructor(protected route: ActivatedRoute, protected reportsService: ReportsService, protected grphservice: GraphService, protected authService: MsalService, private datePipe: DatePipe, protected userservice: UserService, protected poordersummaryservice: PoOrderDataServiceService, protected router: Router,
    protected matdialog: MatDialog,
    private fb: UntypedFormBuilder, protected securitysso: SsoSecurityService, protected translate: TranslateService, protected session: SessionStorageService,
    private dateAdapter: DateAdapter<Date>) {
    super(route, reportsService, grphservice, authService, userservice, poordersummaryservice,
      router, matdialog, securitysso, translate, session);
    this.createForm();
    let lang = this.userData.language.toLowerCase();
    if (lang === 'fr') {
      this.dateTimeFormat = "medium";
      this.dateFormat = "mediumDate";
      this.dateAdapter.setLocale(this.userData.language.toLowerCase());
    }

  }

  createForm() {
    this.rcSummaryForm = this.fb.group({
      receivedDate: ['', Validators.required],



    });

  }

  ngAfterViewInit() {
    this.viewDetailsEnable = true;
    if (this.sequenceNumber)
      this.poordersummaryservice.getPODetailsData(this.sequenceNumber).subscribe(data => {
        this.orderdetailsresponse = data;
        this.viewDetailsEnable = data.ocReceived === 'Y' ? false : true;
        this.ocAccessEnable();
        this.orderdetailsdatasource = new MatTableDataSource(data.orderDetailsDtoList);
        this.orderdetailsdatasource.paginator = this.paginator;
        this.orderdetailsdatasource.sort = this.sort;
        this.maxDate = new Date();
        this.updateForm();
        if (this.ocRcButtonEnable) {
          this.rcSummaryForm.disable();
        }

      });


  }
  // sortData(sort: Sort) {
  //   this.sortableColumn=new SortableColumn('','','');
  //   const sortedData: boolean | Array<any> = this.sortableColumn.sortTableData(sort, this.orderdetailsdatasource.data, this.displayedColumns);
  //   if (sortedData) {
  //     this.orderdetailsdatasource.data = sortedData as Array<any>;
  //   }
  // }

  updateForm() {
    let date = new Date(this.orderdetailsresponse.receivedDate);
    // this.datepipe.transform(this.myDate, 'yyyy/MM/dd');

    //  date = date.slice(1,11)
    this.rcSummaryForm = this.fb.group({
      receivedDate: [date, Validators.required]


    });

  }

  approveRC1() {
    let date = JSON.stringify(this.rcSummaryForm.controls.receivedDate.value)
    date = date.slice(1, 11)
    let status = this.getStatus();
    // this.poordersummaryservice.approveRC(this.sequenceNumber, date, status,this.userData.sequenceNumber).subscribe(data => {
    //   this.approveReport();
    //   //this.backToSummary();
    // })
    // const loginRequest = {
    //   scopes: ["user.read"],
    //   prompt: 'login',
    //  }

    // this.authService.loginPopup(loginRequest).subscribe(result=>{

    //   this.grphservice.init(result.accessToken);
    //   this.grphservice.getProfile().then(u=>{
    //   if(u === this.user.userData.upn) {
    //     let date = JSON.stringify(this.rcSummaryForm.controls.receivedDate.value)
    //     date = date.slice(1,11)
    //         let status=this.getStatus();
    //         this.poordersummaryservice.approveRC(this.sequenceNumber,date,status).subscribe(data=>{

    //           this.backToSummary();
    //          })
    //   }else{
    //     this.matdialog.open(ApproveDialogComponent);
    //   }
    //   });


    // })


  }


  approveRC() {
    let token=this.userservice.getObject("Reauthorization");
    let tokenValid=token?this.isTokenExpired(token):false;
    if (tokenValid) {

      let dialogData = {
        title: this.userData.language === 'EN' ? 'Authenticate to Approve' : 'Authentifiez pour approuver',
        message: "",
        orderType: 'RC'

      }
      let dialogRef: any = this.matdialog.open(ApprovedDialogComponent, {
        data: dialogData, panelClass: 'appoved-class'
      }).afterClosed().subscribe(actionName => {
        if (actionName === true) {
          // dialogRef.close();
          this.approveReport();
        }
      });
    } else {
      this.startMsalPopupReauth(() => this.approveReport());
    }

  }


  approveReport() {
    let date = JSON.stringify(this.rcSummaryForm.controls.receivedDate.value)
    date = date.slice(1, 11)
    let status = this.getStatus();
    let str:StoreMaintainenceResponse =this.user.stores.find(str=> str.storeNumber===""+this.orderdetailsresponse.storeNumber);
    let po_extensiton={"firstName":this.userData.firstName,"lastName":this.userData.lastName,"license": str.license};

    this.poordersummaryservice.approveRC(this.sequenceNumber, date, status,this.userData.sequenceNumber,po_extensiton).subscribe(data => {
      this.clearUnsavedRcChanges();
      this.orderdetailsresponse.status = status;
      this.orderdetailsresponse.statusName = status === 4 ? 'Signed' : "Reported";
      this.rcSummaryForm.disable();
      this.ocAccessEnable();
      this.openReportPDF();

    })
  }


  openDialog() {
    if (!this.ocRcButtonEnable && this.orderdetailsresponse.status < 4 && this.hasUnsavedRcChanges()) {

      let french = "Si vous quittez cette confirmation de réception sans l'approuver, les modifications que vous avez apportées ne seront pas sauvegardées."
      let english = "If you exit this RC without approving it, the changes you have made will not be saved."
      this.matdialog.open(YesNoDynamicTitleMessageDialogComponent, {

        data: {
          title: "Confirmation",
          message: this.userData.language === "EN" ? english : french,
          yesButton: true,
          noButton: false,
          cancelButton: true,
          yesText: "Ok",
          noText: null,
          cancelText: this.userData.language === "EN" ? "Cancel" : "Annuler"
        }
        , panelClass: 'my-class'
      }).afterClosed().subscribe(res => {
        if (res == "Yes") {
          this.removeData();

        } else
          if (res == "No") {
            this.approveRC();
          }
      })
    } else {
      this.backToSummary();
    }
  }


  removeData() {
    this.poordersummaryservice.removePOReportedDetails(this.orderdetailsresponse.sequenceNumber).subscribe(data => {
      this.clearUnsavedRcChanges();
      this.backToSummary();
    })
  }

  private rcUnsavedKey(): string {
    return 'rc-unsaved-' + this.orderdetailsresponse.sequenceNumber;
  }

  private hasUnsavedRcChanges(): boolean {
    return this.userservice.getObject(this.rcUnsavedKey()) === true;
  }

  private clearUnsavedRcChanges(): void {
    this.userservice.setObject(this.rcUnsavedKey(), false);
  }


  updateDiscrepancy(detailssequenceNumber, orderDto: OrderDetails) {

    let orderdetailsresponse: OrderDetailsResponse = new OrderDetailsResponse();
    orderdetailsresponse = this.orderdetailsresponse;
    orderdetailsresponse.orderDetailsDtoList = [];
    orderdetailsresponse.orderDetailsDtoList.push(orderDto);
    this.poordersummaryservice.getPoDetailsById(orderdetailsresponse);
    this.userservice.setObject("report-rc", orderdetailsresponse);



    this.router.navigate(["/dcn-esign/order-summary/receipt-confirmation/" + this.sequenceNumber + "/update-discrepancy/" + detailssequenceNumber]);
  }

  getStatus() {
    let status = 4;
    this.orderdetailsresponse.orderDetailsDtoList.forEach(data => {
      if (data.reason != undefined && data.reason !== null) {
        status = 5;
        return status;
      }
    })
    return status;

  }

  toggleBlocking() {
    this.blockUI.start(this.userData.language==='EN'?"Complete the authentication step in the newly opened verification window.": "Veuillez compléter l'étape d'authentification dans la fenêtre de vérification nouvellement ouverte.");

    setTimeout(() => {
      this.blockUI.stop();
      if(this.signReceived===false){
        window.location.reload();
      }

    }, 90000);

  }


}
